export enum FeatureConstants {
    RulesEngine = "RulesEngine",
    WellFeatures = "WellFeatures",
    //NewReportConfig = "NewReportConfig",
    BulkCreateWells = "BulkCreateWells",
    WellQuickTrend = "WellQuickTrend",
    WellReviewUseRollingAvgVariance = "WellReviewUseRollingAvgVariance",
    WellReviewDisplaySubcategories = "WellReviewDisplaySubcategories",
    ReportConfigurationSupportsWells = "ReportConfigurationSupportsWells",
    ReportConfigurationSupportsEvents = "ReportConfigurationSupportsEvents",
    WellReviewIdentifyDisabledAnalytics = "WellReviewIdentifyDisabledAnalytics",
    //SelfServicePollingSchedule = "SelfServicePollingSchedule",
    TankBatteryFeatures = "TankBatteryFeatures",
    //CreateRules = "CreateRules",
    AdvancedEditRules = "AdvancedEditRules",
    //SimulateRules = "SimulateRules",
    //CanDisableRecipients = "CanDisableRecipients",
    //HybridServiceR1 = "HybridServices-R1",
    FeatureTiers = "FeatureTiers",
    //RuleActionsR2 = "RuleActions-R2",
    //ManageTemplates = "ManageTemplates",
    //SummaryListingSectionConfiguration = "SummaryListingSectionConfiguration",
    //GraphConfig = "GraphConfig",
    //SharedImageViewLibraryEnabled = "SharedImageViewLibraryEnabled",
    SharedImageViewLibraryAdmin = "SharedImageViewLibraryAdmin",
    //TankRenderingVersion2 = "TankRenderingVersion2",
    // DeviceDetailsConfiguration = "DeviceDetailsConfiguration",
    // AzureMaps = "AzureMaps",
    //ImageViewLayerStyles = "ImageViewLayerStyles",
    EnableTagWriteDownConfiguration = "EnableTagWriteDownConfiguration",
    NavigationV2 = "NavigationV2",
    AdvancedCommMgmt = "AdvancedCommMgmt",
    MasterIdentifierEditDialog = "MasterIdentifierEditDialog",
    HeaderAndActionsV2='HeaderAndActionsV2',
    UpdateUIDsV2='UpdateUIDsV2',
    TrendPlotWidthAlignment='TrendPlotWidthAlignment'
}